import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export const Mollogotchi = React.lazy(() => import('./mollogotchi'));
export const QuizSaqGenz = React.lazy(() => import('./quiz-theme'));
export const QuizTheme = React.lazy(() => import('./quiz-theme'));
export const RecoursCollectifs = React.lazy(() => import('./recours-collectifs'));
export const AiCanvas = React.lazy(() => import('./ai-canvas'));
export const AiParle = React.lazy(() => import('./ai-parle'));
